import { Component, OnInit } from '@angular/core';

import Swal from 'sweetalert2';
import { filter } from 'rxjs/operators';

import { FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { Route, Router, RouterModule } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

// import {ToastrModule} from 'ngx-toastr'

import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import Locals from 'ngx-editor/lib/Locals';
import { LoginService } from '../../../login-service';
@Component({
  selector: 'app-admin-signup',
  templateUrl: './admin-signup.component.html'
})
export class AdminSignupComponent implements OnInit {
  roleAssign:boolean=false;
  firstName:string;
  lastName:string;
  emailID:string;
  emailAddress:string;
  newPassword:any;
  confirmPassword:any;
 
 userID:any;
 addUser:boolean=false;
  usersList: any;

  pager: {
    totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number;
    endPage: number; startIndex: number; endIndex: number;
    pages: number[];
  };
  searchWord: string = "";
  pagedItems: any;
  SearchList:any;
  closeResult: string;

  currentpage: number=1;
  
  searchText: any;
  usersListDetails:any;
  userType: any;
  registerForm: FormGroup;
  submitted = false;
  rolesList:any;
  RoleID: any;
  usertypeid:string;
  selectedUsersListid=[];
  dynamicRows: number;
  rowsOnPageSet: any[];
  rowCount: any;
  rowsOnPage: any;
  p: any;
  count: any;
  savefilter: any;
  constructor(private modalService: NgbModal
    
,private formBuilder: FormBuilder,private router:Router,private loginService:LoginService,private activateRoute:ActivatedRoute) {
      this.userType='Admin';
    this.usertypeid=localStorage.getItem("userTypeid");;
  }

  ngOnInit(): void {
    this.loginService.getselectpage(10)
    this.GetUsers();
    this.GetRoles();
    this.registerForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
       newPassword: ['', [Validators.required, Validators.minLength(6)]],
       retypePassword: ['', [Validators.required]]
  }, { 
    validator: this.ConfirmedValidator('newPassword', 'retypePassword')
  }
  );
  }
  get f() { return this.registerForm.controls; }
navigate()
{
   this.addUser=true;
}

onSubmit() {
 
  
//   this.firstName=this.registerForm.value.firstName;
//   this.lastName=this.registerForm.value.lastName;
//   this.emailAddress=this.registerForm.value.email;
// this.newPassword=this.registerForm.value.newPassword;
// this.confirmPassword=this.registerForm.value.retypePassword;
    this.submitted = true;

    // stop here if form is invalid
    // if (this.registerForm.invalid) {
    //   console.log("invalid")
    //     return;
    // }
    // else
    // {
      if(!this.firstName||!this.lastName||!this.emailAddress||!this.newPassword||!this.confirmPassword){
        console.log("fqlse")
        return;}
      const jsonData = {
        firstnameparm:this.firstName,
    lastnameparm:this.lastName,
    usernameparm:this.firstName+" "+this.lastName,
    emailparm:this.emailAddress,
    passwordparm:this.newPassword,
    usertypeidparm:4,
    issubscribedparam:"y",
    isverifiedparam:"y"
    // socialusersparm:"",
    
   
      };
     
      this.loginService.SaveUsers(jsonData).subscribe(data=>{
    
        this.loginService.showSuccess("User created","");
        
        this.userID=data['_body'].toString();
       this.GetUsers();
this.ClearFiields();
      }
      );
     
    // }

  }

  CancelSignup(){
    this.addUser=false;
  }
delete(ID,type) {

  if(type=="delete")
  {
  const json={
    userid:ID,
    param:"d"
  }
  this.loginService.DeleteUser(json).subscribe(data => { 
    if(type=='delete'){
    //  Swal.fire("Deleted successfully")   
     this.loginService.showSuccess("Deleted successfully!",''); 
    this.GetUsers();
    setTimeout(() => {
     // this.message = "";
    }, 1000);
  }
  })

}

else if(type=="deactivate")
{
  const json={
    userid:ID,
    param:"n"
  }
  
  this.loginService.DeleteUser(json).subscribe(data => { 
    
      // Swal.fire("User deactivated successfully") 
      this.loginService.showSuccess("User Deactivated successfully!",'');
    this.GetUsers();
    setTimeout(() => {
     // this.message = "";
    }, 1000);
  
  })
}
else if(type=="activate")
{
  const json={
    userid:ID,
    param:"y"
  }
  
  this.loginService.DeleteUser(json).subscribe(data => { 
    
      // Swal.fire("User activated successfully") 
      this.loginService.showSuccess("User activated successfully!",'');
    this.GetUsers();
    setTimeout(() => {
     // this.message = "";
    }, 1000);
  
  })
}
}


DeleteUser(user,type){

  event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to ' +type+ ' this user:' + user.user_name,///
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      this.delete(user.id,type);//
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })


}
checkedtrue(u){

  const json={
    userid:u.id
  }
  this.loginService.ReactivateUser(json).subscribe(data => { 
 
    // Swal.fire("User Reactivated successfully")
    this.loginService.showSuccess("User Reactivated successfully!",'');
    this.GetUsers();
    setTimeout(() => {
     // this.message = "";
    }, 1000);
  
  })
}
changepagination(page:number){
  this.count=this.rowsOnPage
  console.log(this.rowsOnPage)
  this.loginService.getselectpage(this.rowsOnPage)
  this.loginService.getPager(this.usersListDetails.length, page);
  this.setPage(page)
}
setPage(page: number) {

   this.p=page;
  this.pager = this.loginService.getPager(this.usersListDetails.length, page);
  this.count=this.pager.pageSize
  this.pagedItems = this.usersListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
  this.usersList = this.usersListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);

}

Searchtext(){
  this.usersList = this.savefilter;
  
      let tempCompany = this.usersList.filter(
        (item) => {
          return (
            (item.user_name !== null && item.user_name.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
            (item.user_type !== null && item.user_type.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
            (item.email !== null && item.email.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
          );
        }
  
      );
      this.usersList = tempCompany;
      this.assigndynamicarray(tempCompany)
    // if(this.searchText==""){
    //   this.GetUsers();
    //   this.assigndynamicarray(this.usersList)
    // }
    if(this.searchText !== ""){
      this.usersListDetails = tempCompany;
      this.setPage(1);
  }else{
      this.usersListDetails = this.savefilter;      
      this.assigndynamicarray(this.usersList)

      this.setPage(1);
  }
 
 
}
SaveRoleByUser(){
  const json={
    userID:this.userID,
    email:this.emailID,
    roleID:this.RoleID,
    updatedBy:'SuperAdmin'
  }
 
 this.loginService.SaveUserRole(json).subscribe(data=>{
  this.loginService.showSuccess("Role Assigned Successfully..!", "");
  
 });
}

open(content,userData) {

  this.emailID=userData.email;
  this.userID=userData.id;
  this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}

private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return  `with: ${reason}`;
  }
}
RoleAssignment(){
  this.roleAssign=true;
}
selectRow(id,e){
  if(e.target.checked){
   this.selectedUsersListid.push(e.target.id)
  }
  else{
   var index = this.selectedUsersListid.indexOf(e.target.id);
  this.selectedUsersListid.splice(index,1)
  }
}
DeleteSelected(){
 if(this.selectedUsersListid.length==0){
   return;
 }
 else{
   event.stopPropagation();
   Swal.fire({
     title: 'Are you sure?',
     text: 'You want to delete the selected rows' ,///
     icon: 'warning',
     showCancelButton: true,
     confirmButtonText: 'Yes',
     cancelButtonText: 'No'
   }).then((result) => {
     if (result.value) {
       this.deleterows(this.selectedUsersListid);//
     } else if (result.dismiss === Swal.DismissReason.cancel) {
 
     }
   })
 }
}
deleterows(list){
for(var i=0;i<list.length;i++){
 this.delete(list[i],'delete');
 this.selectedUsersListid=[];
}
}

GetUsers()
{
  this.loginService.GetUsers(3).subscribe(data=>
    {  
            this.usersList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
            let filterAdmins=this.usersList.filter(x=>x.user_type==this.userType)
          
            if(filterAdmins.length>0){
              this.usersListDetails=filterAdmins;
              this.savefilter=this.usersListDetails
              this.assigndynamicarray(this.usersListDetails)
              this.setPage(1);
            }
            else{
              this.usersList=[];
            }
    });
}
assigndynamicarray(userslist)
{
  this.dynamicRows=10
  this.rowsOnPageSet=[];
  this.rowCount = userslist.length;
  console.log(this.rowCount,this.dynamicRows)
  while (this.dynamicRows < this.rowCount) {
    this.rowsOnPageSet.push(this.dynamicRows);
    this.dynamicRows = this.dynamicRows + 10;
    console.log(this.rowsOnPageSet)
  }
  if (!this.rowsOnPageSet.includes(this.rowCount))
    this.rowsOnPageSet.push(this.rowCount);
  if (this.rowsOnPageSet.length === 1) {
    if (this.rowsOnPageSet[0] <= 10)
      this.rowsOnPage = this.rowsOnPageSet[0];
  }
  this.rowsOnPage = this.rowsOnPageSet[0];
}
GetRoles(){
  this.loginService.GetRoles(this.usertypeid).subscribe(data=>
    {  
            this.rolesList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));

    
});
}
rolesChange(event){
  this.RoleID=event.target.value;

}
ClearFiields(){
  this.firstName="";
  this.lastName='';
  this.emailAddress="";
  this.newPassword="";
  this.confirmPassword="";

}

ConfirmedValidator(controlName: string, matchingControlName: string){
  return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
          return;
      }
      if (control.value !== matchingControl.value) {
          matchingControl.setErrors({ confirmedValidator: true });
      } else {
          matchingControl.setErrors(null);
      }
  }
}
}

